import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Drawer, Fab, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import AnimateButton from 'ui-component/extended/AnimateButton'
import { IconFileText } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import NotificationList from 'layout/MainLayout/Header/NotificationSection/NotificationList';
import { toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import RefreshIcon from '@mui/icons-material/Refresh';
// import axiosInstance from 'custom-axios';

const statusIcons = {
    success: <CheckCircleIcon style={{ color: 'green' }} />,
    error: <ErrorIcon style={{ color: 'red' }} />,
    NA: <InfoIcon style={{ color: 'gray' }} />
};

const ClientPortfolioDrawer = ({ called_from, userId, setActiveParentStep, setActiveChildStep }) => {

    let loginType = localStorage.getItem('login_type');
    let loginId = localStorage.getItem('login_id');
    let managerLoginId = localStorage.getItem('manager_id');
    let managerId = loginType == 'client' ? managerLoginId : loginId;

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [clientPortfolioData, setClientPortfolioData] = useState([])
    const [missingInfoData, setClientMissingInfoData] = useState([])


    const fetchUserPortfolio = async () => {

        try {
            // showLoader()

            const response = await axiosInstance.get(`api/user-quick-view-details/${managerId}/${userId}`);

            if (response.status === 200) {

                setClientMissingInfoData(response.missing_information_data)
                const chartDataArray = response.data.map((portfolio) => {
                    const chartTitle = portfolio.assets.map((asset) => asset.title);
                    const chartValue = portfolio.assets.map((asset) => Number(asset.value));

                    return {
                        chartData: portfolio,
                        chartTitle,
                        chartValue,
                        editableValues: portfolio.assets.reduce((acc, asset) => {
                            acc[asset.title] = asset.value;
                            return acc;
                        }, {}),
                    };
                });


                setClientPortfolioData(chartDataArray);
                // setLoadingChart(true);
            }

        } catch (error) {
            console.error("Error submitting questions:", error);
            toast.error("Something went wrong. Please try again.");
        }/*  finally {
                    hideLoader()
                } */
    }

    const handleRefresh = () => {
        fetchUserPortfolio()
    }

    const handleToggle = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen(!open);
    };

    const handleStepLink = async (parentStep, childStep) => {
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: parentStep, child_step: childStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(parentStep)
                setActiveChildStep(childStep)
                setOpen(false);
            }

        } catch (error) {
            console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    }

    useEffect(() => {
        fetchUserPortfolio()
    }, [])
    return (
        <>
            <Tooltip title="Quick View">
                <Fab
                    component="div"
                    onClick={handleToggle}
                    size="medium"
                    variant="circular"
                    color="secondary"
                    sx={{
                        backgroundColor: '#FFB6C1',
                        borderRadius: 0,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        borderTopRightRadius: '50%',
                        borderBottomRightRadius: '4px',
                        top: '35%',
                        position: 'fixed',
                        right: 10,
                        zIndex: theme.zIndex.speedDial
                    }}
                >
                    {/* <AnimateButton type="rotate"> */}
                    <IconButton color="inherit" size="large" disableRipple>
                        <IconFileText />
                    </IconButton>
                    {/* </AnimateButton> */}
                </Fab>
            </Tooltip>

            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    sx: {
                        width: '40%',
                        padding: '20px',
                        paddingTop: called_from == 'client' ? '70px' : ''
                    }
                }}
            >
                <PerfectScrollbar component="div"> {/*  set width for inner content  */}
                    <Paper sx={{ marginLeft: 0 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" justifyContent="space-between" sx={{ marginLeft: '5px', marginTop: '3px' }}>
                                    <Grid item>
                                        <Stack direction="row" spacing={2}>

                                            {/* <Typography variant="subtitle1"><strong>Client Activity</strong></Typography> */}

                                            {/* {notificationData.length > 0 &&
                                                <Chip
                                                    size="small"
                                                    label={notificationData.length}
                                                    sx={{
                                                        color: theme.palette.background.default,
                                                        bgcolor: theme.palette.warning.dark
                                                    }}
                                                />
                                            } */}
                                        </Stack>
                                    </Grid>
                                    {/* <Grid item>
                                        <Typography component={Link} to="#" variant="subtitle2" color="primary">
                                            Mark as all read
                                        </Typography>
                                    </Grid> */}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ paddingTop: '0px' }}>
                                <PerfectScrollbar style={{ height: '100%', /* maxHeight: 'calc(109vh - 205px)', */ overflowX: 'hidden' }} >
                                    {/* <NotificationList userId={userId} clientPortfolioData={clientPortfolioData} /> */}
                                    <Grid className='mt-2'>
                                        <Grid
                                            container
                                            direction="row"
                                            sx={{
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                            className="padding10px"
                                        >
                                            <Grid>
                                                <Typography variant="subtitle2" color="primary" sx={{ fontSize: '13px' }}>
                                                    {clientPortfolioData[0]?.chartData?.user_name}
                                                </Typography>
                                            </Grid>
                                            <Grid>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    endIcon={<RefreshIcon />}
                                                    onClick={handleRefresh}
                                                >
                                                    Refresh
                                                </Button>
                                            </Grid>
                                        </Grid>


                                        {/* <Grid container spacing={1} alignItems="center" >

                                        </Grid> */}
                                        <Divider />
                                        {clientPortfolioData?.map((portfolioData, portfolioIndex) => {

                                            return (
                                                <div className='portfolio-section' key={portfolioIndex}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ArrowDropDownIcon />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                        >
                                                            {/* <Typography component="span" variant='h6' >Portfolio: {portfolioData.chartData?.portfolio_name}</Typography> */}
                                                            <Grid container direction="row" spacing={2}>
                                                                <Grid item xs={4}>
                                                                    <Typography sx={{ fontWeight: 'bold' }} component="span">
                                                                        Account Type
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography sx={{ fontWeight: 'bold' }} component="span">
                                                                        Recommended Portfolio
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography sx={{ fontWeight: 'bold' }} component="span">
                                                                        Selected Portfolio
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                    <Typography component="span">
                                                                        {portfolioData.chartData?.account_type_label}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography component="span">
                                                                        {/* {portfolioData.chartData?.portfolio_name} */}
                                                                        {portfolioData.chartData.portfolio_name_list.find(
                                                                            (option) => option.portfolio_type_id === portfolioData.chartData.account_recommended_portfolio
                                                                        )?.portfolio_name || ""}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography component="span">

                                                                        {portfolioData.chartData.portfolio_name_list.find(
                                                                            (option) => option.portfolio_type_id === portfolioData.chartData.account_selected_portfolio
                                                                        )?.portfolio_name || ""}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </AccordionSummary>

                                                        <AccordionDetails>
                                                            {portfolioData.chartData?.category.map((row, categoryIndex) => {

                                                                // Filter assets based on the current category ID
                                                                const categoryAssets = portfolioData.chartData?.assets.filter(
                                                                    (asset) => asset.category === row.id && row.id !== 99
                                                                );

                                                                return (
                                                                    <div className='chart-asset-category' key={categoryIndex}>
                                                                        <h6>{row.category}</h6>
                                                                        <ul>
                                                                            {categoryAssets.map((asset, assetIndex) => {
                                                                                return (
                                                                                    <li key={assetIndex} style={{ padding: '5px' }}>
                                                                                        <span>
                                                                                            {asset.title} : {portfolioData.editableValues[asset.title]}%
                                                                                        </span>
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </div>
                                                                );
                                                            })}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                    <Divider />
                                                    {/* {(portfolioIndex > 0) && <Divider />} */}
                                                </div>
                                            );
                                        })}
                                    </Grid>
                                    {Object.keys(missingInfoData).map((section) => (
                                        <Box key={section} sx={{ padding: 2 }}>
                                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                {section?.charAt(0)?.toUpperCase() + section?.slice(1)}
                                            </Typography>
                                            <List>
                                                {missingInfoData[section].map((item, index) => (
                                                    <ListItem key={index} divider>
                                                        <ListItemIcon>
                                                            {statusIcons[item.status] || <InfoIcon />}
                                                        </ListItemIcon>
                                                        {/* <ListItemText */}
                                                        <Box sx={{
                                                            flex: 1, // Take remaining space
                                                            overflow: 'hidden'
                                                        }}>
                                                            <ListItemText
                                                                primary={item.title}
                                                                secondary={
                                                                    item.status === "NA"
                                                                        ? "This section is not applicable."
                                                                        : item.message
                                                                }
                                                                sx={{
                                                                    whiteSpace: 'normal', // Allow the text to wrap
                                                                    wordWrap: 'break-word', // Ensures long words break and wrap
                                                                    overflow: 'visible', // Allow overflow if the message exceeds container width
                                                                    width: 'auto', // Use full available width
                                                                }}
                                                            />
                                                        </Box>
                                                        {item.status === 'error' && (
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                endIcon={<ArrowForwardIosIcon />}
                                                                onClick={() => handleStepLink(item.parent_step, item.child_step)}
                                                            >
                                                                Go to form
                                                            </Button>
                                                        )}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    ))}
                                </PerfectScrollbar>
                            </Grid>

                            {/* <Divider />
                            <Grid container justifyContent="center">
                                <CardActions sx={{ p: 1.25 }}>
                                    <Button size="small" disableElevation>
                                        View All
                                    </Button>
                                </CardActions>
                            </Grid> */}
                        </Grid>
                    </Paper>
                </PerfectScrollbar>
            </Drawer>
        </>
    )
}

export default ClientPortfolioDrawer